import { render, staticRenderFns } from "./temperature-humidity-card.vue?vue&type=template&id=c73f844a&scoped=true&"
import script from "./temperature-humidity-card.vue?vue&type=script&lang=ts&"
export * from "./temperature-humidity-card.vue?vue&type=script&lang=ts&"
import style0 from "./temperature-humidity-card.vue?vue&type=style&index=0&id=c73f844a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73f844a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VIcon})
